import { useRouteError } from "react-router-dom";

export default function Error() {
	const error = useRouteError();
	console.error(error);

	return (
		<div
			id="error-page"
			className="w-screen h-screen flex justify-center items-center flex-col gap-3"
		>
			<h1 className="text-4xl font-black">Oops!</h1>
			<p className="text-xl">Sorry, an unexpected error has occurred.</p>
			<p className="text-xl">
				<i>{error.statusText || error.message}</i>
			</p>
		</div>
	);
}
